import React, { FC, PropsWithChildren } from 'react'
import styles from './formElements.module.scss'
import classNames from 'classnames'

type FormRadioProps = {
  checked?: boolean
  name: string
  onClick?: (ev: React.SyntheticEvent<HTMLElement>) => void
  readOnly?: boolean
  size?: 'small' | 'large'
  text?: string
  value?: string | number
  customStyles?: string
}

const FormRadio: FC<PropsWithChildren<FormRadioProps>> = (props) => {
  const {
    children,
    checked,
    name,
    size = 'small',
    onClick,
    readOnly,
    text,
    value,
    customStyles = '',
  } = props
  return (
    <label
      className={classNames(styles.radio, {
        [styles.radioLarge]: size === 'large',
        [customStyles]: Boolean(customStyles),
      })}
      data-readonly={!!readOnly}
      data-type='radio'
    >
      <input
        aria-checked={!!checked}
        checked={!!checked}
        name={name}
        onChange={() => {} /* React Warning - when no Function */}
        onClick={onClick}
        value={value}
        readOnly={!!readOnly}
        type='radio'
      />

      <span className={styles.icon} aria-hidden='true' data-type='radio-circle-icon'>
        {checked && <span className={styles.checkMark} data-checked={!!checked} />}
      </span>

      {text && (
        <p className='defaultTypographySmall' data-type='radio-text'>
          {text}
        </p>
      )}

      {children || ''}
    </label>
  )
}

export default FormRadio
